import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";

const menuData = [
  {
    category: "Main",
    items: [
      { label: "Dashboards", icon: "bx bx-home", link: "/dashboards" },
      { label: "Platform Performance", icon: "bx bx-line-chart", link: "/platform-performance" },
      { label: "Platform Earnings", icon: "bx bx-dollar-circle", link: "/platform-earnings" },
    ],
  },
  {
    category: "Management",
    items: [
      { label: "Industries", icon: "bx bx-briefcase", link: "/industries" },
      { label: "Skills", icon: "bx bx-certification", link: "/skills" },
      { label: "Companies", icon: "bx bx-buildings", link: "/companies" },
      { label: "Platform fee", icon: "bx bx-buildings", link: "/platformfee" },
      { label: "Documents", icon: "bx bx-buildings", link: "/documents" },
      {
        label: "Location",
        icon: "bx bx-map",
        key: "location",
        subItems: [
          { label: "Countries", icon: "bx bx-globe", link: "/countries" },
          { label: "Cities", icon: "bx bx-building-house", link: "/cities" },
        ],
      },
    ],
  },
  {
    category: "User Management",
    items: [
      { label: "Users", icon: "bx bx-user", link: "/users" },
      { label: "Disputes", icon: "bx bx-error-circle", link: "/disputes" },
    ],
  },
];

const Sidebar = ({ collapsed, onToggle }) => {
  const [openMenus, setOpenMenus] = useState({});
  const location = useLocation();

  // Auto-open parent menu when child is active
  useEffect(() => {
    const currentPath = location.pathname;

    // Find if current path matches any subItem
    menuData.forEach(section => {
      section.items.forEach(item => {
        if (item.subItems) {
          const isChildActive = item.subItems.some(subItem =>
            currentPath === subItem.link || currentPath.startsWith(subItem.link + '/')
          );
          if (isChildActive) {
            setOpenMenus(prev => ({ ...prev, [item.key]: true }));
          }
        }
      });
    });
  }, [location.pathname]);

  const toggleMenu = (key) =>
    setOpenMenus((prev) => ({ ...prev, [key]: !prev[key] }));

  const scrollSidebar = (direction) => {
    const container = document.getElementById("sidebar-scroll");
    if (container)
      container.scrollLeft += direction === "left" ? -100 : 100;
  };

  // Check if a menu item is active
  const isActive = (link, subItems = []) => {
    const currentPath = location.pathname;

    // Check if current path matches the link exactly or starts with it (for nested routes)
    if (link && (currentPath === link || currentPath.startsWith(link + '/'))) {
      return true;
    }

    // Check if any subItem is active
    if (subItems.length > 0) {
      return subItems.some(subItem =>
        currentPath === subItem.link || currentPath.startsWith(subItem.link + '/')
      );
    }

    return false;
  };

  // Check if a submenu item is active
  const isSubItemActive = (link) => {
    const currentPath = location.pathname;
    return currentPath === link || currentPath.startsWith(link + '/');
  };

  return (
    <aside
      id="sidebar"
      className={`app-sidebar sticky ${collapsed ? "sidenav-toggled" : ""}`}
    >
      {/* Header Logo */}
      <div className="main-sidebar-header bg-gradient">
        <a href="#" className="header-logo">
          <img src="New/assets/images/brand-logos/desktop-logo.png" alt="logo" className="desktop-logo" />
          <img src="New/assets/images/brand-logos/toggle-logo.png" alt="logo" className="toggle-logo" />
          <img src="New/assets/images/brand-logos/desktop-dark.png" alt="logo" className="desktop-dark" />
          <img src="New/assets/images/brand-logos/toggle-dark.png" alt="logo" className="toggle-dark" />
          <img src="New/assets/images/brand-logos/desktop-white.png" alt="logo" className="desktop-white" />
          <img src="New/assets/images/brand-logos/toggle-white.png" alt="logo" className="toggle-white" />
        </a>
      </div>

      {/* Sidebar Menu */}
      <div className="main-sidebar" id="sidebar-scroll">
        <nav className="main-menu-container nav nav-pills flex-column sub-open">
          {/* Scroll Buttons */}
          <div className="slide-left" onClick={() => scrollSidebar("left")}>
            <i className="fe fe-chevron-left" />
          </div>

          <ul className="main-menu">
            {menuData.map((section, i) => (
              <React.Fragment key={i}>
                <li className="slide__category">
                  <span className="category-name">{section.category}</span>
                </li>

                {section.items.map((item, j) => (
                  <li
                    key={j}
                    className={`slide ${item.subItems ? "has-sub" : ""} ${openMenus[item.key] ? "open" : ""
                      } ${isActive(item.link, item.subItems) ? "active" : ""}`}
                  >
                    <Link
                      to={item.link || "#"}
                      className={`side-menu__item ${isActive(item.link, item.subItems) ? "active" : ""}`}
                      onClick={(e) => {
                        if (item.subItems) {
                          e.preventDefault();
                          toggleMenu(item.key);
                        }
                      }}
                    >
                      <i className={`${item.icon} side-menu__icon`} />
                      <span className="side-menu__label">{item.label}</span>
                      {item.subItems && (
                        <i
                          className={`fe fe-chevron-right side-menu__angle ${openMenus[item.key] ? "rotate-90" : ""
                            }`}
                        />
                      )}
                    </Link>

                    {/* Submenu */}
                    {item.subItems && (
                      <ul
                        className="slide-menu child"
                        style={{
                          display: openMenus[item.key] ? "block" : "none",
                        }}
                      >
                        {item.subItems.map((sub, k) => (
                          <li key={k} className={`slide ${isSubItemActive(sub.link) ? "active" : ""}`}>
                            <Link
                              to={sub.link}
                              className={`side-menu__item ${isSubItemActive(sub.link) ? "active" : ""}`}
                            >
                              {sub.icon && (
                                <i
                                  className={`${sub.icon} me-2`}
                                  style={{ fontSize: "14px" }}
                                />
                              )}
                              {sub.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </React.Fragment>
            ))}
          </ul>

          <div className="slide-right" onClick={() => scrollSidebar("right")}>
            <i className="fe fe-chevron-right" />
          </div>
        </nav>
      </div>

      {/* Sidebar Toggle - Removed internal toggle, controlled by parent */}
    </aside>
  );
};

export default Sidebar;